/*
 * Rewards button in the product page's earn-coins panel.
 *
 * The "Redeem Rewards" popup belongs to the Appstle Loyalty app and is opened by the app's own
 * controls (the cart drawer widget, and the floating pill this theme hides in
 * component-loyalty-widget.css). The app exposes no documented storefront API to open it, so this
 * proxies a click onto whichever of the app's own triggers is in the document — a hidden trigger
 * still runs its handler, which is why hiding the floating pill does not break this.
 *
 * The button ships with `hidden` and is only revealed once a trigger has been found: if the app
 * embed is off, or renames its markup in a future version, the panel shows no dead control.
 */
(function () {
  /*
   * The app's own REWARDS control, as it ships today:
   *
   *   div#appstle-loyalty-redeem-widget-block
   *     div.appstle-loyalty_cart_widget_wrapper
   *       div.loyalty-cart-widget-button
   *         div.loyalty-cart-widget-points-store-credits-info
   *         div.loyalty-cart-widget-rewards-btn[type=button]   <- opens the popup
   *
   * Note it is a <div type="button">, not a real button — element-name selectors would miss it.
   * Exact class first, then progressively looser fallbacks for future app versions.
   */
  var TRIGGER_SELECTORS = [
    '.loyalty-cart-widget-rewards-btn',
    '[class*="loyalty"][class*="rewards-btn"]',
    '[class*="loyalty-cart-widget"] [type="button"]',
    '[id*="appstle"][id*="redeem"] [type="button"]',
    '[class*="appstle"][class*="loyalt"] [type="button"]',
    '[id*="appstle"][id*="loyalt"] [type="button"]',
    // Older/other placements: the floating launcher (hidden by the theme, still clickable
    // programmatically) and any real button the widget might render instead.
    '[id*="appstle"][id*="launch"]',
    '[class*="appstle"][class*="launch"]',
    '[class*="appstle"] button',
    '[class*="loyalty"] button',
  ];

  var WAIT_MS = 10000;
  var POLL_MS = 400;

  function findTrigger() {
    for (var i = 0; i < TRIGGER_SELECTORS.length; i++) {
      var node;
      try {
        node = document.querySelector(TRIGGER_SELECTORS[i]);
      } catch (error) {
        continue; // a selector the browser rejects must not stop the rest
      }
      // Our own button carries no appstle class, but guard anyway so we never click ourselves.
      if (node && !node.hasAttribute('data-pi-rewards')) return node;
    }
    return null;
  }

  function bind(button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      // Re-found on every click: the app re-renders its widget when the cart changes.
      var trigger = findTrigger();
      if (trigger) trigger.click();
    });
  }

  function reveal(button) {
    if (button.dataset.piRewardsReady === 'true') return;
    button.dataset.piRewardsReady = 'true';
    button.hidden = false;
    bind(button);
  }

  function watch(button) {
    if (findTrigger()) {
      reveal(button);
      return;
    }

    // The app embed boots after the theme, so the trigger usually appears a moment later.
    var elapsed = 0;
    var timer = setInterval(function () {
      elapsed += POLL_MS;
      if (findTrigger()) {
        clearInterval(timer);
        reveal(button);
      } else if (elapsed >= WAIT_MS) {
        clearInterval(timer);
      }
    }, POLL_MS);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-pi-rewards]').forEach(watch);
  }

  init(document);

  // The product section re-renders on variant change, which replaces this button.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  /*
   * Exposed for surfaces whose markup is swapped by something other than a section load — the cart
   * page's order summary is re-rendered by cart.js on every quantity change, so the row's button is
   * a new element each time and has to be watched again. Reusing this rather than copying the
   * trigger list keeps one definition of "the app's own control".
   */
  window.piRewardsPopup = {
    init: init,
    watch: watch,
    findTrigger: findTrigger,
  };
})();
